// Chart.js
// Redux Container for Chart View

// Imports
import { connect } from 'react-redux';
import ChartView from '../components/ChartView/';

// State Mapper
const mapStateToProps = state => ({
  orders: state.order,
  products: state.product,
  clients: state.client,
});

// Action Mapper
const mapDispatchToProps = dispatch => ({
});

// Exports
export default connect(mapStateToProps, mapDispatchToProps)(ChartView);



// WEBPACK FOOTER //
// ./src/containers/Chart.js